export default __webpack_public_path__ + "static/media/mobile-menu.77048064.svg";